module.exports = "<div>\n\tManage shares dialog-like card goes here :)\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/shaas/components/manage-shares/manage-shares.template.html
// module id = 1322
// module chunks = 0